module.exports = __webpack_public_path__ + "e070ffafde0d641079574bd23c87d60c.png";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags/mk.png
// module id = 1054
// module chunks = 0